module.exports = __webpack_public_path__ + "img/robot.16359c8c.png";